import { PROJECT_META } from "@/data";
import { useI18n } from "@/i18n";
import { Reveal, FramedImage } from "./motion";

const Card = ({ p, meta, index }) => (
  <div data-testid={`project-${index}`} className={`${meta.span} group`}>
    <div className="relative overflow-hidden">
      {meta.images ? (
        <div className="grid grid-cols-2 gap-3">
          {meta.images.map((src, k) => (
            <FramedImage
              key={k}
              src={src}
              alt={p.title}
              className="aspect-[4/5] w-full"
              imgClass="transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
            />
          ))}
        </div>
      ) : (
        <FramedImage
          src={meta.image}
          alt={p.title}
          className={`w-full ${meta.ratio}`}
          imgClass="transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
        />
      )}
      <span className="absolute left-4 top-4 bg-[#f4f4f0]/85 px-3 py-1 font-body text-[10px] uppercase tracking-[0.2em] text-[#1c1c1a] backdrop-blur">
        {String(index + 1).padStart(2, "0")}
      </span>
    </div>
    <div className="mt-6 flex items-start justify-between gap-4 border-t border-[#dcdcd6] pt-5">
      <div>
        <h3 className="font-display text-3xl tracking-tight text-[#1c1c1a] md:text-4xl">{p.title}</h3>
        <p className="mt-2 font-body text-[11px] uppercase tracking-[0.18em] text-[#9e8d7b]">{p.client}</p>
      </div>
      <div className="shrink-0 text-right font-body text-[11px] uppercase tracking-[0.14em] text-[#5c5c57]">
        <div>{p.year}</div>
        <div className="mt-1">{p.value}</div>
      </div>
    </div>
    <p className="mt-4 max-w-xl font-body text-base leading-relaxed text-[#5c5c57]">{p.scope}</p>
    <p className="mt-3 font-body text-[11px] uppercase tracking-[0.18em] text-[#5c5c57]">{p.location}</p>
  </div>
);

export const Projects = () => {
  const { t } = useI18n();
  const s = t.projectsSection;
  return (
    <section
      id="projets"
      data-testid="projects-section"
      className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
    >
      <Reveal>
        <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-body text-[11px] uppercase tracking-[0.28em] text-[#9e8d7b]">{s.label}</span>
            <h2 className="mt-6 font-display text-5xl leading-[0.95] tracking-tight text-[#1c1c1a] md:text-7xl">
              {s.headingA}
              <br />
              <span className="italic text-[#9e8d7b]">{s.headingB}</span>
            </h2>
          </div>
          <p className="max-w-xs font-body text-sm leading-relaxed text-[#5c5c57]">{s.subtext}</p>
          {s.note && (
            <p className="mt-3 max-w-xs font-body text-[11px] uppercase tracking-[0.18em] text-[#9e8d7b]">{s.note}</p>
          )}
        </div>
      </Reveal>

      <div className="grid grid-cols-1 gap-x-6 gap-y-20 lg:grid-cols-12">
        {t.projects.map((p, i) => (
          <Card key={i} p={p} meta={PROJECT_META[i]} index={i} />
        ))}
      </div>
    </section>
  );
};
